'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'jug-detergent';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e519';
var svgPathData = 'M128 64l0-32 64 0 0 32-64 0zM96 64L80 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 32 0 64 0 32 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-40c0-13.3-10.7-24-24-24L120 0C106.7 0 96 10.7 96 24l0 40zm32 96l128 0c53 0 96 43 96 96l0 192c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-192c0-53 43-96 96-96zm0-32C57.3 128 0 185.3 0 256L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-192c0-70.7-57.3-128-128-128l-128 0zm128 80c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48s48-21.5 48-48l0-96c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faJugDetergent = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;